export default __webpack_public_path__ + "static/Plots0050-2e4bd13778e65bc3bc69c09511889c9e.jpg";